import { FC, useCallback } from 'react'

import { RowButtons } from '../../../../components/rowButtons/RowButtons'
import { GlobalPartnerTypes } from '../../models/globalPartnerTypes'

import { GLOBAL_PARTNER_TYPE_OPTIONS } from './configs'
import { IGlobalPartnerTypeButtonsProps } from './models/globalPartnerTypeButtonsProps'

export const GlobalPartnerTypeButtons: FC<IGlobalPartnerTypeButtonsProps> = ({
  value,
  translationKeyPrefix,
  onOptionClick,
}) => {
  const generateTranslationKey = useCallback(
    (option: GlobalPartnerTypes) => {
      return `${translationKeyPrefix}--${option.toLowerCase()}-button`
    },
    [translationKeyPrefix]
  )

  return (
    <RowButtons
      value={value}
      options={GLOBAL_PARTNER_TYPE_OPTIONS}
      generateTranslationKey={generateTranslationKey}
      onOptionClick={onOptionClick}
    />
  )
}
